import { Base64 } from 'js-base64';

// eslint-disable-next-line consistent-return
export default (base64Location) => {
  try {
    const decodedLocation = Base64.decode(base64Location);

    return JSON.parse(decodedLocation);
  } catch (error) {
    console.log('Error while decoding base64 string: ', error);
  }
};
